import { useState } from "react";
import { it } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const dmy = (d) => (d ? d.split("-").reverse().join("/") : "");
const iso = (d) => d.toLocaleDateString("sv-SE");

export const DateDMY = ({ value, onChange, min, testid, className = "", placeholder = "gg/mm/aaaa" }) => {
  const [open, setOpen] = useState(false);
  const [y, m, d] = (value || "").split("-").map(Number);
  const sel = value ? new Date(y, m - 1, d) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`h-10 w-full rounded-md border px-3 bg-white flex items-center justify-between text-sm ${className}`} data-testid={testid}>
          <span className={value ? "" : "text-slate-400"}>{value ? dmy(value) : placeholder}</span><CalendarDays className="w-4 h-4 text-slate-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={it} selected={sel} defaultMonth={sel}
          disabled={min ? (x) => iso(x) < min : undefined}
          onSelect={(x) => { if (x) { onChange(iso(x)); setOpen(false); } }} data-testid={`${testid}-calendar`} />
      </PopoverContent>
    </Popover>
  );
};
